import { useCallback } from 'react';

import { AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { UrlParams, PaginatedAppointmentTypeList } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams, urlParamsFromUrl } from 'utils/functions';

interface QueryKeyType {
  pageParam?: UrlParams;
}

interface IUseAppointmentTypes {
  ordering?: string;
  limit?: string;
}

function useAppointmentTypes({
  ordering,
  limit = '20',
}: IUseAppointmentTypes): UseInfiniteQueryResult<AxiosResponse<PaginatedAppointmentTypeList>> {
  const fetchAppointmentTypes = useCallback(
    ({
      pageParam = { limit, offset: '0' },
    }: QueryKeyType): Promise<AxiosResponse<PaginatedAppointmentTypeList>> => {
      const params = pageParam;
      if (ordering) {
        params.ordering = ordering.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`).concat(',pk');
      }
      return client.get(`appointment-types/?${encodeUrlParams(pageParam)}`);
    },
    [limit, ordering],
  );

  return useInfiniteQuery(['appointmentType', ordering], fetchAppointmentTypes, {
    getNextPageParam: page => {
      return page.data.next ? urlParamsFromUrl(page.data.next) : undefined;
    },
  });
}

export default useAppointmentTypes;
